import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
  colors: {
    primary: '#f5f5e8',
    secondary: '#e0e0d0',
    border: '#d4d4c4',
    text: '#333',
    accent: '#ff6b6b',
  },
  fonts: {
    main: '"Comic Sans MS", cursive, sans-serif',
  },
  shadows: {
    light: '0 4px 8px rgba(0, 0, 0, 0.2)',
    medium: '0 6px 12px rgba(0, 0, 0, 0.3)',
    dark: '0 10px 20px rgba(0, 0, 0, 0.3)',
  },
};

export default theme;
